module.exports = __webpack_public_path__ + "static/sb_cover-e07bec8015795bf2227d11fa27f9a47c.jpg";